import { I18nProvider } from '@lingui/react';
import { createFileRoute, Outlet, useMatchRoute } from '@tanstack/react-router';
import { FormTranslationsProvider } from '../-components/form-translations-provider';
import { AddDonationFloat } from './-components/add-donation-float';
import { useStartDonationCount } from './-components/donation-count';
import { NotFoundPage } from './-components/not-found';

export const Route = createFileRoute('/www')({
	// No `head()`: `__root` declares and preloads Rethink Sans for every page in this app.
	component: RouteComponent,
	// For a `notFound()` from a page that exists (`/www/$` covers the rest); otherwise the root's PORTAL 404 renders.
	notFoundComponent: NotFoundComponent,
});

/** Wrapped in the provider for the same reason RouteComponent is — see the note inside it. */
function NotFoundComponent() {
	const { i18n } = Route.useRouteContext();
	return (
		<I18nProvider i18n={i18n}>
			<NotFoundPage />
		</I18nProvider>
	);
}

function RouteComponent() {
	// Request-scoped Lingui instance from router context — see $portalId/route.tsx.
	const { i18n } = Route.useRouteContext();
	// Started here so the Solutions odometer counts the whole visit, not just that page.
	useStartDonationCount();
	const matchRoute = useMatchRoute();
	// The certificate card is for the website, not for the screens it hosts: the live counter and the internal pages.
	const isScreen = Boolean(
		matchRoute({ to: '/www/live-counter' }) || matchRoute({ to: '/www/.internal', fuzzy: true }),
	);
	return (
		<I18nProvider i18n={i18n}>
			<FormTranslationsProvider>
				<Outlet />
				{!isScreen && <AddDonationFloat />}
			</FormTranslationsProvider>
		</I18nProvider>
	);
}
